module.exports = function (value) {
  value = value[0] != undefined ? value[0] : value;
  if (value && value.amount && value.title && value.title.length) {
    const arr = value.title.split('; ').filter(item => item);
    let out = '';
    for (let i = 0; i < arr.length; i++) {
      out += `<p class="coupon"><svg class="icon--coupon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.37 21.21"><use xlink:href="#couponBlack"/></svg>${arr[i]}</p>`;
    }
    return out;
  }
};
